import { render, staticRenderFns } from "./ProgramPagePreview.vue?vue&type=template&id=b1bc3550"
import script from "./ProgramPagePreview.vue?vue&type=script&lang=js"
export * from "./ProgramPagePreview.vue?vue&type=script&lang=js"
import style0 from "./ProgramPagePreview.vue?vue&type=style&index=0&id=b1bc3550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports